import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { canViewClientPhi } from '../../utils/developmentPhi';

/**
 * Blocks screens whose purpose is a client or resident list.
 * Aggregate report routes should not use this gate.
 */
const DevelopmentPhiGate = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading || !currentUser) {
    return null;
  }

  if (canViewClientPhi(currentUser)) {
    return children;
  }

  return (
    <Container className="py-4">
      <Alert variant="secondary" className="mb-0">
        Client names are hidden for this account.
      </Alert>
    </Container>
  );
};

export default DevelopmentPhiGate;
